import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=35ea5e06&scoped=true"
import script from "./selector.vue?vue&type=script&setup=true&lang=js"
export * from "./selector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./selector.vue?vue&type=style&index=0&id=35ea5e06&prod&lang=scss"
import style1 from "./selector.vue?vue&type=style&index=1&id=35ea5e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea5e06",
  null
  
)

export default component.exports